<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm key</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Id" placeholder="Nhập id" [formGroup]="searchForm" formControlName="idLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-text label="Tên" placeholder="Nhập tên" [formGroup]="searchForm" formControlName="nameLike"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-select label="Loại key" placeholder="Chọn loại key" [formGroup]="searchForm" formControlName="type" [optionList]="rsaKeyTypeOptionList"></app-input-select>
                </div>
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="rsaKeyStatusOptionList"></app-input-select>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchRsaKey()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Id</th>
                    <th scope="col">Loại key</th>
                    <th scope="col">Tên</th>
                    <th scope="col">Ngày tạo</th>
                    <th scope="col">Từ ngày</th>
                    <th scope="col">Đến ngày</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="insertRsaKey()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="sysRsaKeyList && !loading">
                <tr *ngFor="let sysRsaKey of sysRsaKeyList;index as sysRsaKeyIndex">
                    <td scope="col">{{(sysRsaKeyPagination.currentPage-1)*sysRsaKeyPagination.pageSize + sysRsaKeyIndex+1}}</td>
                    <td scope="col">{{sysRsaKey.id}}</td>
                    <td scope="col">{{rsaKeyTypeOptionMap[sysRsaKey.type]}}</td>
                    <td scope="col">{{sysRsaKey.name}}</td>
                    <td scope="col">{{sysRsaKey.createDate | date:'dd/MM/yyyy, HH:mm:ss'}}</td>
                    <td scope="col">{{sysRsaKey.notBefore | date:'dd/MM/yyyy, HH:mm:ss'}}</td>
                    <td scope="col">{{sysRsaKey.notAfter | date:'dd/MM/yyyy, HH:mm:ss'}}</td>
                    <td scope="col">{{rsaKeyStatusOptionMap[sysRsaKey.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewRsaKey(sysRsaKey)">Xem</button>
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="editRsaKey(sysRsaKey)">Sửa</button>
                            <button type="button" class="btn btn-danger"  *ngIf="hasEditPerm" (click)="deleteRsaKey(sysRsaKey)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="sysRsaKeyPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':sysRsaKeyPagination.currentPage == 1}">
                      <a class="page-link" (click)="sysRsaKeyPageChange(sysRsaKeyPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="sysRsaKeyPagination.currentPage > 3">
                      <a class="page-link" (click)="sysRsaKeyPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="sysRsaKeyPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of sysRsaKeyPagination.pageList"  [ngClass]="{'active':sysRsaKeyPagination.currentPage == page}">
                    <a class="page-link" (click)="sysRsaKeyPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="sysRsaKeyPagination.currentPage < sysRsaKeyPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="sysRsaKeyPagination.currentPage < sysRsaKeyPagination.pageCount - 2">
                    <a class="page-link" (click)="sysRsaKeyPageChange(sysRsaKeyPagination.pageCount)">{{sysRsaKeyPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':sysRsaKeyPagination.currentPage == sysRsaKeyPagination.pageCount}">
                    <a class="page-link"  (click)="sysRsaKeyPageChange(sysRsaKeyPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

